import request from "./../utils/request";

export function getCustomLoginFormInputs() {
    return request.get(`/public/loginForms/get-all?cache=true`);
}



// WEBPACK FOOTER //
// ./src/api/customLoginForm.js